<template>
  <div id="app">
    <router-view />
    <!-- 右侧浮动客服 -->
    <div class="floating-service" @mouseenter="showPanel = true" @mouseleave="showPanel = false">
      <div class="service-btn">
        <i class="fas fa-headset"></i>
      </div>
      <div class="service-popup" v-show="showPanel">
        <div class="popup-header">
          <span>在线客服</span>
          <i class="fas fa-times"></i>
        </div>
        <div class="popup-body">
          <div class="qr-icon">
            <img src="/static/images/微信二维码.png" alt="微信二维码" class="qr-img" />
          </div>
          <p>扫码添加客服微信</p>
          <p class="tip">企文达，让老板经营企业更简单</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      showPanel: false
    }
  }
}
</script>

<style>
* {
  box-sizing: border-box;
}
body {
  margin: 0;
  padding: 0;
  font-family: 'Poppins', 'PingFang SC', 'Microsoft YaHei', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #333;
  background: #fff;
}
a {
  text-decoration: none;
  color: inherit;
}
img {
  display: block;
  max-width: 100%;
}

/* 浮动客服 - 全局样式 */
.floating-service {
  position: fixed;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  z-index: 99999;
}
.service-btn {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: linear-gradient(135deg, #07c160, #06ad56);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 26px;
  cursor: pointer;
  box-shadow: 0 6px 24px rgba(7,193,96,0.45);
  transition: all 0.3s ease;
}
.service-btn:hover {
  transform: scale(1.1);
  box-shadow: 0 8px 28px rgba(7,193,96,0.55);
}
.service-popup {
  position: absolute;
  right: 70px;
  top: 50%;
  transform: translateY(-50%);
  width: 280px;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 12px 40px rgba(0,0,0,0.15);
  overflow: hidden;
}
.popup-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  background: linear-gradient(135deg, #07c160, #06ad56);
  color: #fff;
  font-size: 15px;
  font-weight: 600;
}
.popup-header i {
  cursor: pointer;
  font-size: 14px;
  opacity: 0.8;
  transition: opacity 0.2s;
}
.popup-header i:hover {
  opacity: 1;
}
.popup-body {
  padding: 32px 24px;
  text-align: center;
}
.qr-icon {
  width: 140px;
  height: 140px;
  margin: 0 auto 18px;
  background: #f0f9f4;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
.qr-img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.qr-icon i {
  font-size: 70px;
  color: #07c160;
}
.popup-body p {
  font-size: 15px;
  color: #333;
  margin: 0 0 10px;
  font-weight: 500;
}
.tip {
  font-size: 13px !important;
  color: #888 !important;
  font-weight: 400 !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue